/**
 * A function that clones the passed date. The parameter could be `null`.
 *
 * @param date - The initial date value.
 * @returns - A new `Date` instance.
 *
 * @example
 * ```ts-no-run
 * cloneDate(new Date(2016, 0, 1)); // returns new Date(2016, 0, 1);
 * cloneDate(null); // returns null
 * ```
 */
export var cloneDate = function (date) { return date ? new Date(date.getTime()) : null; };



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-date-math/dist/es/clone-date.js
// module id = 89
// module chunks = 93